module.exports = __webpack_public_path__ + "static/media/17.d728e868.jpg";